// extracted by mini-css-extract-plugin
export default {"listContainer":"VariantList_listContainer__MkIeY","container":"VariantList_container__pyBBM","spacer":"VariantList_spacer__F8VCJ","new":"VariantList_new__TBh+1"};